import { Button, Card, Grid, Typography, useTheme } from '@material-ui/core';
import AssembleiaPautas from 'components/AssembleiaPautas/AssembleiaPautas';
import { AssembleiaIcon, ColaboradorIcon, MaletaIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import Loading from 'components/Loading';
import PageTitle from 'components/PageTitle/PageTitle';
import Page from 'components/PrivateContainer';
import { AssembleiaPautaStatus } from 'enuns/AssembleiaPautaStatus';
import { RestricaoConta } from 'enuns/RestricaoConta';
import { VotoCanalVozPath } from 'library/Routes';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { assembleiasAssessorActionsClearedCurrentEvent, assembleiasAssessorActionsLoadContasCanalVoz, assembleiasAssessorBuscarPautaPorCpf } from 'store/modules/AssembleiasAssessorActions';
import { IReducer } from 'store/Reducer';
import { wsStartStop } from 'utils/AssembleiaUtils';
import useStyle from './style';
import Tabela from './Tabela';
import VotacaoFinalizada from './VotacaoFinalizada';

interface RouteParams {
  idAssembleia: string;
  cpfRepresentante: string;
}

export default function () {
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const { opened: wsOpened } = useSelector((state: IReducer) => state.wsAssembleias);
  const { t } = useTranslation();
  const classes = useStyle();
  const history = useHistory();
  const { idAssembleia, cpfRepresentante } = useParams<RouteParams>();
  const [isLoading] = useState(false);
  const [listaPresenca, setListaPresenca] = useState<AssembleiaContaAssessor[]>();
  const [ nomeRepresentante, setNomeRepresentante ] = useState<string>('');
  const location = useLocation();
  const dispatch = useDispatch();
  const { evento } = useSelector((state: IReducer) => state.assembleiasAssessor);
  const { setToolbarReadOnly } = useContext(LayoutContext);
  const theme = useTheme();
  const [loadedContas, setLoadedContas] = useState<boolean>(false);
  const [loadedPautas, setLoadedPautas] = useState<boolean>(false);

  const initialized = useMemo<boolean>(() => {
    return loadedContas && loadedPautas;
  }, [loadedContas, loadedPautas])

  const buscaNomeRepresentante = useCallback((cpf: string, lista:AssembleiaContaAssessor[]) => {
    if (lista && lista.length > 0 && nomeRepresentante === '') {
      let nomeRepresentante = lista.filter(it => it.cpfRepresentante === cpf).find(it => it.cpfRepresentante === cpf)?.nomeRepresentante;
      if (nomeRepresentante === undefined || nomeRepresentante === '') {
        nomeRepresentante = lista.filter(it => it.cpfCnpj === cpf).find(it => it.cpfCnpj === cpf)?.nome;
      }
      if(nomeRepresentante !== undefined)
        setNomeRepresentante(nomeRepresentante.toString())
    }
  }, [setNomeRepresentante, nomeRepresentante]);

  // const isColaborador = useMemo(() => {
  //   if (!listaPresenca || isLoading) return false;
  //   return (
  //     listaPresenca.length === 1 &&
  //     listaPresenca[0].flgColaborador === true
  //   );
  // }, [isLoading, listaPresenca]);


  const getPresencas = useCallback(() => {
    dispatch(
      assembleiasAssessorActionsLoadContasCanalVoz(
        parseInt(idAssembleia),
        atob(cpfRepresentante),
        (data: AssembleiaContaAssessor[]) => {
          setLoadedContas(true);
          if (data && data.length) {
            setListaPresenca(data)
            buscaNomeRepresentante(atob(cpfRepresentante), data);
          }
        },
        error => toast.error( error.message )
      )
    );
  }, [dispatch, idAssembleia, setListaPresenca, cpfRepresentante, buscaNomeRepresentante, setLoadedContas]);

  const getPautas = useCallback(() => {
    dispatch(
      assembleiasAssessorBuscarPautaPorCpf(
        parseInt(idAssembleia),
        atob(cpfRepresentante),
        () => setLoadedPautas(true),
        error => toast.error( error.message )
      )
    )
  }, [dispatch, idAssembleia, cpfRepresentante, setLoadedPautas]);

  // tem pauta liberada, mas todas liberadas já foram votadas, aparece a mensagem que já votou ...

  // não tem pauta liberada mas possui pautas bloqueadas ou encerradas, aparece a nova.

  const todasPautasEncerradasOuBloqueadas = useMemo(() => {
    if (!evento?.pautas?.length || isLoading) return false;
    return !evento.pautas.find(pauta => pauta.status === AssembleiaPautaStatus.Liberada)
  }, [evento, isLoading])

  const todasPautasLiberadasTemVoto = useMemo(() => {
    if (!evento?.pautas?.length || isLoading) return false;
    return !evento.pautas.find(pauta => pauta.status === AssembleiaPautaStatus.Liberada && pauta.votos.length === 0);
  }, [evento, isLoading])

  const votacaoFinalizada = useMemo(() => {
    return todasPautasLiberadasTemVoto || todasPautasEncerradasOuBloqueadas;
  }, [todasPautasLiberadasTemVoto, todasPautasEncerradasOuBloqueadas]);

  const temRestricoes = useMemo<boolean>(() => {
    return !listaPresenca?.find(it => !it.restricao);
  }, [listaPresenca])

  useEffect(() => {
    if (usuario) {
      wsStartStop(
        usuario,
        Number(idAssembleia),
        dispatch,
        wsOpened
      )
    }
  }, [usuario, location, idAssembleia, dispatch, wsOpened])

  useEffect(() => {
    getPresencas();
    getPautas();
  // eslint-disable-next-line 
  },[])

  useEffect(() => {
    if (evento?.needLoadPautas) {
      getPautas();
    }
  }, [evento, getPautas])

  useEffect(() => {
    setToolbarReadOnly(true);
    return () => {
      setToolbarReadOnly(false);
      dispatch(assembleiasAssessorActionsClearedCurrentEvent());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (votacaoFinalizada) {
    return <VotacaoFinalizada todasPautasEncerradasOuBloqueadas={todasPautasEncerradasOuBloqueadas} todasPautasLiberadasTemVoto={todasPautasLiberadasTemVoto} cpf={atob(cpfRepresentante).replace(/[^0-9]/g, '')} idAssembleia={idAssembleia} />;
  }

  return isLoading ? (
    <Loading />
  ) : initialized && (
    <Page
      header={
        <React.Fragment>
          <PageTitle title={t('canalVoz.title')} className={classes.mainTitle} />
          <Typography component="p" className={classes.subhead}>
            {t('canalVoz.subhead', { representante: nomeRepresentante })}
          </Typography>
        </React.Fragment>
      }
    >
      {!!listaPresenca && listaPresenca.filter(it => it.presente).length > 0 && (
        <Tabela idEvento={idAssembleia} dadosAssociados={listaPresenca}></Tabela>
      )}
      {temRestricoes && (
        <Grid item xs={12}>
          <Card className={classes.adviceColaborador}>
            { listaPresenca?.find(it => it.restricao === RestricaoConta.Colaborador) && <ColaboradorIcon color={theme.palette.primary.main} /> }
            { listaPresenca?.find(it => it.restricao === RestricaoConta.ColaboradorPJ || it.restricao === RestricaoConta.ColaboradorMei) && <MaletaIcon color={theme.palette.primary.main} /> }
            <Typography component="p">{t('canalVoz.textPessoaColaborador')}</Typography>
          </Card>
          <div className={classes.adviceColaboradorConfirm}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AssembleiaIcon />}
              onClick={() => history.replace(VotoCanalVozPath.replace(':idAssembleia', idAssembleia))}
            >
              {t('canalVoz.botaoSair')}
            </Button>
          </div>
        </Grid>
      )}
      {evento?.pautas && evento?.pautas.length! && !temRestricoes && (
        <Grid item xs={12} className={classes.pautas}>
          <AssembleiaPautas
            pautas={evento?.pautas}
            flgVotoPresencial
          />
        </Grid>
      )} 
    </Page>
  );
}
